import React, { RefObject, useEffect, useRef } from 'react';
import JsBarcode, { BaseOptions, Code128Options, Ean8Options, Ean13Options } from 'jsbarcode';

import { Flex } from 'components/styled/Flex';

type TJsBarcodeOptions = BaseOptions | Ean8Options | Ean13Options | Code128Options;

export const BarcodePreview = ({
  code,
  jsBarcodeOptions,
  downloadSvgCallbackFn,
}: {
  code: string | undefined;
  jsBarcodeOptions?: TJsBarcodeOptions;
  downloadSvgCallbackFn?: (data: RefObject<SVGSVGElement>) => void;
}) => {
  const svgRef = useRef<SVGSVGElement>(null);

  const defaultJsBarcodeOptions: TJsBarcodeOptions = {
    format: 'CODE128', // most compatible
    displayValue: false,
  };

  useEffect(() => {
    if (svgRef.current && code) {
      JsBarcode(svgRef.current, code, jsBarcodeOptions || defaultJsBarcodeOptions);
      downloadSvgCallbackFn && downloadSvgCallbackFn(svgRef);
    }
  }, [code]);

  return (
    <>
      <Flex justifyContent="center">
        <svg ref={svgRef} />
      </Flex>
    </>
  );
};
